<template>
  <div class="cdt-wrap">
    <table class="cdt-table" v-if="!isInfluencer || $vuetify.breakpoint.smAndUp">
      <thead>
        <tr>
          <th v-for="(header, i) in filteredHeaders" :key="i">{{ header.text }}</th>
        </tr>
      </thead>

      <!-- Not influencer -->
      <tbody v-if="!isInfluencer">
        <tr v-if="loading">
          <td :colspan="filteredHeaders.length" class="cdt-empty">Loading…</td>
        </tr>
        <tr v-else-if="!items.length">
          <td :colspan="filteredHeaders.length" class="cdt-empty">No campaigns found.</td>
        </tr>
        <tr v-for="item in items" :key="item.uuid">
          <td>
            <router-link :to="{ name: 'campaign', params: { id: item.uuid } }" class="cdt-link">
              {{ item.name }}
            </router-link>
          </td>
          <td v-if="hasHeader('business')">
            <router-link :to="{ name: 'business', params: { id: item.business.uuid } }" class="cdt-link">
              {{ item.business.display_name }}
            </router-link>
          </td>
          <td>
            <i
              class="fal cdt-visibility-icon"
              :class="item.hidden ? 'fa-eye-slash' : 'fa-eye'"
              :title="item.hidden ? 'Privat' : 'Public'"
            ></i>
          </td>
          <td>
            <template
              v-if="
                item.cost_per_action_percent !== null &&
                  item.cost_per_action_fixed !== null
              "
            >
              {{ item.cost_per_action_percent | local_numbers }}% + DKK
              {{ item.cost_per_action_fixed | local_numbers }}
            </template>
            <template v-else-if="item.cost_per_action_percent !== null">
              {{ item.cost_per_action_percent | local_numbers }}%
            </template>
            <template v-else-if="item.cost_per_action_fixed !== null">
              DKK {{ item.cost_per_action_fixed | local_numbers }}
            </template>
          </td>
          <td>{{ item.influencers.length | local_numbers }}</td>
          <td><campaign-status-icon :value="item" show-text></campaign-status-icon></td>
          <td>{{ item.created_at | utc_to_local_datetime }}</td>
        </tr>
      </tbody>

      <!-- Influencer (desktop) -->
      <tbody v-else>
        <tr v-if="loading">
          <td :colspan="filteredHeaders.length" class="cdt-empty">Loading…</td>
        </tr>
        <tr v-else-if="!items.length">
          <td :colspan="filteredHeaders.length" class="cdt-empty">No campaigns found.</td>
        </tr>
        <tr v-for="item in items" :key="item.uuid">
          <td><campaign-status-icon :value="item" show-text></campaign-status-icon></td>
          <td>
            <router-link :to="{ name: 'campaign', params: { id: item.uuid } }" class="cdt-link">
              {{ item.name }}
            </router-link>
          </td>
          <td>
            <template v-if="item.business">{{ item.business.display_name }}</template>
          </td>
          <td>
            <template
              v-if="
                item.cost_per_action_percent !== null &&
                  item.cost_per_action_fixed !== null
              "
            >
              {{ item.cost_per_action_percent | local_numbers }}% + DKK
              {{ item.cost_per_action_fixed | local_numbers }}
            </template>
            <template v-else-if="item.cost_per_action_percent !== null">
              {{ item.cost_per_action_percent | local_numbers }}%
            </template>
            <template v-else-if="item.cost_per_action_fixed !== null">
              DKK {{ item.cost_per_action_fixed | local_numbers }}
            </template>
          </td>
          <td>{{ item.min_followers | local_numbers }}</td>
          <td>{{ item.created_at | utc_to_local_datetime }}</td>
          <td>{{ item.ending_at | utc_to_local_datetime }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Influencer (mobile compact) -->
    <table class="cdt-table cdt-table--compact" v-else>
      <tbody>
        <tr v-if="loading">
          <td class="cdt-empty">Loading…</td>
        </tr>
        <tr v-else-if="!items.length">
          <td class="cdt-empty">No campaigns found.</td>
        </tr>
        <tr
          v-for="item in items"
          :key="item.uuid"
          class="cdt-row--clickable"
          @click="openCampaignCard(item)"
        >
          <td class="cdt-nowrap"><campaign-status-icon :value="item" show-text></campaign-status-icon></td>
          <td><span class="cdt-nowrap">{{ item.name }}</span></td>
        </tr>
      </tbody>
    </table>

    <div class="cdt-pagination">
      <v-pagination
        v-model="currPage"
        :length="total"
        :total-visible="7"
        @input="handlePageChange"
      ></v-pagination>
    </div>

    <v-dialog
      v-model="openCampaignDialog"
      max-width="550px"
      @click:outside="openCampaignCard(null)"
    >
      <campaign-list-card
        v-if="selectedCampaign"
        :campaign="selectedCampaign"
        class="w-100"
      >
        <template v-slot:footer>
          <router-link
            :to="{ name: 'campaign', params: { id: selectedCampaign.uuid } }"
            class="cdt-btn cdt-btn--primary cdt-dialog-cta"
          >
            See campaign
          </router-link>
        </template>
      </campaign-list-card>
    </v-dialog>
  </div>
</template>
<script>
import utc_to_local_datetime from "@/helpers/filters/utc_to_local_datetime";
import local_numbers from "@/helpers/filters/local_numbers";
import CampaignStatusIcon from "../icons/CampaignStatusIcon";
import CampaignListCard from "../cards/CampaignListCard";

export default {
  components: { CampaignStatusIcon, CampaignListCard },
  filters: {
    utc_to_local_datetime,
    local_numbers
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    page: {
      type: Number
    },
    total: {
      type: Number
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    exclude: {
      type: Array,
      required: false,
      default: () => []
    },
    isInfluencer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    headers: [],
    currPage: 1,
    selectedCampaign: null,
    openCampaignDialog: false
  }),
  computed: {
    filteredHeaders() {
      let finalHeaders = [];
      this.headers.forEach(item => {
        if (!this.exclude.includes(item.value)) {
          finalHeaders.push(item);
        }
      });
      return finalHeaders;
    },
    isBusinessPage() {
      return this.$route.name === "business" ? true : false;
    }
  },
  methods: {
    handlePageChange(value) {
      this.$emit("changePage", value);
    },
    hasHeader(value) {
      return (
        this.filteredHeaders.filter(item => item.value === value).length > 0
      );
    },
    setHeaderColumn() {
      if (!this.isInfluencer && this.isBusinessPage) {
        this.headers = [
          { text: "Campaign", value: "name", sortable: false },
          { text: "Visibility", value: "visability", sortable: false },
          { text: "Commission", value: "percent", sortable: false },
          { text: "Influencers", value: "influencers", sortable: false },
          { text: "Status", value: "status", sortable: false },
          { text: "Created at", value: "created_at", sortable: false }
        ];
      } else if (!this.isInfluencer) {
        this.headers = [
          { text: "Campaign", value: "name", sortable: false },
          { text: "Brand", value: "business", sortable: false },
          { text: "Visibility", value: "visability", sortable: false },
          { text: "Commission", value: "percent", sortable: false },
          { text: "Influencers", value: "influencers", sortable: false },
          { text: "Status", value: "status", sortable: false },
          { text: "Created at", value: "created_at", sortable: false }
        ];
      } else {
        this.headers = [
          { text: "Status", sortable: false },
          { text: "Campaign", sortable: false },
          { text: "Brand", sortable: false },
          { text: "Commission", sortable: false },
          { text: "Follower requirements", sortable: false },
          { text: "Start date", sortable: false },
          { text: "End date", sortable: false }
        ];
      }
    },
    openCampaignCard(campaign) {
      this.openCampaignDialog = true;
      this.selectedCampaign = campaign;
    },
    updateData() {
      this.setHeaderColumn();
    }
  },
  watch: {
    page(index) {
      this.currPage = index;
      window.scrollTo(0, 0);
    },
    items() {
      this.currPage = this.page;
      this.updateData();
    }
  },
  created() {
    this.currPage = this.page;
    this.updateData();
  }
};
</script>
<style lang="scss" scoped>
.cdt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.cdt-table th {
  text-align: left;
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--ink-3, #888);
  border-bottom: 1px solid var(--line, #eaecf0);
  white-space: nowrap;
}
.cdt-table td {
  padding: 14px 16px;
  border-bottom: 1px solid var(--line, #eaecf0);
  color: var(--ink-1, #111);
  vertical-align: middle;
}
.cdt-table tbody tr:last-child td { border-bottom: none; }
.cdt-table tbody tr:hover td { background: var(--surface-2, #f9f9f9); }

.cdt-link { color: var(--accent, #e05540); text-decoration: none; font-weight: 600; }
.cdt-link:hover { text-decoration: underline; }

.cdt-visibility-icon { color: var(--ink-3, #888); font-size: 14px; }

.cdt-empty { text-align: center; padding: 32px; color: var(--ink-3, #888); font-style: italic; }

.cdt-nowrap { white-space: nowrap; }
.cdt-row--clickable { cursor: pointer; }

.cdt-pagination { display: flex; justify-content: center; padding: 16px 0; }
.cdt-pagination ::v-deep .v-pagination__item--active {
  background: var(--accent, #e05540) !important;
  color: #fff !important;
}

.cdt-btn {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--r-ctrl, 8px);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
}
.cdt-btn.cdt-btn--primary { background: var(--accent, #e05540); }
.cdt-btn.cdt-btn--primary.cdt-dialog-cta { color: #fff !important; }
</style>